import React from 'react';
import { useTranslation } from 'react-i18next';
import { PropertiesItem } from '@/components/Ad/Properties/PropertiesItem';
import { useAdDetails } from '@/views/Ads/useAdDetails';
import { Divider } from '@/components/UI/Divider/Divider.styles';
import { AdProperty } from '@/api/types/ads.types';
import { useServerDataContext } from '@/contexts';

export const Properties = () => {
  const { t } = useTranslation();
  const { adDetails } = useAdDetails();
  const { initialAdDetails } = useServerDataContext();
  const adData = adDetails ?? initialAdDetails;

  const cityProperty = {
    name: t('common.city'),
    value: adData?.region || t('common.no'),
    link: null,
  } as AdProperty;

  return (
    <>
      {adData
        ? [cityProperty, ...adData.properties].map(property => (
            <PropertiesItem key={property.name} adProperty={property} />
          ))
        : Array.from({ length: 5 }, (_, index) => (
            <PropertiesItem key={index} />
          ))}
      <Divider $isSmall />
    </>
  );
};
